import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { MeApi } from 'api';

function useGet(enabled = true) {
  return useAuthQuery(getQueryKeys([KEY]).all, () => MeApi.get(), {
    select: (data) => data.data,
    enabled,
  });
}

export default useGet;
